import { useCallback, useState } from 'react'

import { milestoneAwardSchema } from '@hazel/shared'

/**
 * Notices a milestone on the response to a recorded round.
 *
 * The award rides back with the play rather than arriving on its own
 * endpoint, so this only has to read what is already coming. Held per round —
 * every game keys its round component on the seed — which is what makes it
 * "once, and then out of the way" without anything having to remember to
 * clear it.
 */
export function useMilestone(): {
  readonly milestone: number | null
  readonly notice: (body: unknown) => void
} {
  const [milestone, setMilestone] = useState<number | null>(null)

  const notice = useCallback((body: unknown) => {
    const parsed = milestoneAwardSchema.safeParse(body)

    // No award is the ordinary case and says nothing. A body this cannot read
    // is treated the same way: a missed celebration is a small loss, and a
    // wrong one would be worse.
    if (parsed.success && parsed.data.milestone !== null) setMilestone(parsed.data.milestone)
  }, [])

  return { milestone, notice }
}
